import { render, staticRenderFns } from "./lgj.vue?vue&type=template&id=78bab99e&"
import script from "./lgj.vue?vue&type=script&lang=js&"
export * from "./lgj.vue?vue&type=script&lang=js&"
import style0 from "./lgj.vue?vue&type=style&index=0&id=78bab99e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports